"use client";

export default function DataCardClient() {
  return (
    <div className="pt-16 min-h-screen">
      <iframe
        src="https://www.hemorn.cn/index?k=R3UxL0NUbHQ5MWs9"
        title="流量卡"
        className="w-full border-0"
        style={{ height: "calc(100vh - 4rem)" }}
        allow="clipboard-write; payment"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}
